/**
 * Timezone Command
 * Convert time between timezones
 */
import { Command } from 'commander';
import { UtilsService } from '../../services/utils.service.js';

async function handleTimezoneConversion(
    time: string | undefined,
    options: {
        from: string;
        to: string;
        list: boolean;
    }
): Promise<void> {
    const service = new UtilsService();

    try {
        if (options.list) {
            console.log('🌍 Available Timezones:');
            console.log('────────────────────────────────────────\n');

            const timezones = service.getTimezones();
            timezones.forEach((tz) => {
                console.log(`   ${tz}`);
            });
            console.log();
            return;
        }

        if (!time) {
            console.error('❌ Please provide time to convert or use --list to see available timezones');
            process.exit(1);
        }

        if (!options.from || !options.to) {
            console.error('❌ Please provide both --from and --to timezones');
            process.exit(1);
        }

        const result = service.convertTimezone(time, options.from, options.to);

        console.log('🌍 Timezone Conversion:');
        console.log('────────────────────────────────────────');
        console.log(`   From: ${options.from}`);
        console.log(`   To: ${options.to}`);
        console.log();
        console.log(`   ${result.time}`);
        console.log(`   ISO: ${result.iso}`);
        console.log();
    } catch (error) {
        console.error('❌ Error:', error instanceof Error ? error.message : String(error));
        process.exit(1);
    }
}

export function createTimezoneCommand(): Command {
    const cmd = new Command('timezone')
        .description('Convert time between timezones')
        .argument('[time]', 'Time to convert (e.g., "2024-01-15 10:00")')
        .option('--from <timezone>', 'Source timezone')
        .option('--to <timezone>', 'Target timezone')
        .option('--list', 'Show available timezones')
        .addHelpText('after', `
Examples:
  $ jai1 utils timezone --list
  $ jai1 utils timezone "2024-01-15 10:00" --from "America/New_York" --to "Asia/Tokyo"
  $ jai1 utils timezone "2024-01-15 14:30" --from "UTC" --to "America/Los_Angeles"
  $ jai1 utils timezone "2024-12-25 12:00" --from "Europe/London" --to "Asia/Ho_Chi_Minh"
`)
        .action(async (time, options) => {
            await handleTimezoneConversion(time, options);
        });

    return cmd;
}
